import { render, staticRenderFns } from "./FollowOverView.vue?vue&type=template&id=a872e1dc&scoped=true"
import script from "./FollowOverView.vue?vue&type=script&lang=js"
export * from "./FollowOverView.vue?vue&type=script&lang=js"
import style0 from "./FollowOverView.vue?vue&type=style&index=0&id=a872e1dc&prod&lang=scss&scoped=true"
import style1 from "./FollowOverView.vue?vue&type=style&index=1&id=a872e1dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a872e1dc",
  null
  
)

export default component.exports